<template>
  <ml-input v-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <vs-select v-else v-model="data" autocomplete :disabled="disabled" :placeholder="placeholder" @click="(e) => $emit('click', e)">
    <vs-select-item v-for="option in options" :value="option" :text="option" :key="option" />
  </vs-select>
</template>

<script>
export default {
  name: "CustomOptionSelector",
  props: {
    value: String | Number,
    options: Array,
    disabled: Boolean,
    readonly: Boolean,
    placeholder: {
      type: String,
      default: "선택",
    },
  },
  data() {
    return {
      data: this.value,
    };
  },
  watch: {
    value() {
      this.data = this.value;
    },
    data(/*value*/) {
      this.$emit("input", this.data);
    },
  },
  mounted() {
    if (!this.value) {
      this.data = "";
      this.$emit("input", this.data);
    }
  },
};
</script>

<style scoped></style>
